import type { QueryClientConfig } from '@tanstack/react-query';

/**
 * Requests always go out, whatever the browser says about being online.
 *
 * By default TanStack Query 4 holds every request while `navigator.onLine` is false. Chrome
 * sometimes reports false while the internet works (VPNs, security tools, waking from sleep),
 * so the Google sign-in button and every page spun forever with nothing sent. A request that
 * really has no internet now fails and shows its error instead.
 *
 * 'always' also switches TanStack's reconnect re-read off unless it is set, so it is set back
 * on: a page that failed during a real outage loads again when the connection returns.
 */
export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: { networkMode: 'always', refetchOnReconnect: true },
    mutations: { networkMode: 'always' },
  },
};
